import { Center, Text } from '@wegroup/design-system';
import React from 'react';

interface Props {
  amount: number;
}

const NotificationNumberBadge: React.FC<Props> = ({ amount }) => {
  return (
    <Center w="5" h="5" bg="primary.500" color="white" borderRadius="full">
      <Text textStyle="extraSmallBody">{amount}</Text>
    </Center>
  );
};

export default NotificationNumberBadge;
